const incrementCounter = () => ({
  type: 'INCREMENT',
})

export default incrementCounter
